<script>
import '@assets/css/swap.css'
import '@assets/css/button.css'
import '@assets/css/dashboard.css'
import '@assets/css/invest.css'
import '@assets/css/icon.css'
import '@assets/css/home.css'
import '@assets/css/mypage.css'
import '@assets/css/footer-link.css'
import '@assets/css/policy.css'
import '@assets/css/common.css'

export default {
  props: ['view_mode'],
}
</script>

<template>
  <div :class="[view_mode, `page-${$route.name}`]">
    <router-view></router-view>
  </div>
</template>
